export const ARENA_TUTORIAL_KEY = 'reverse_arena_tutorial_seen_v4';
export { createGuidedTour } from './guided-tour.js';

import { TUTORIALS } from './tutorial-content.js';
export const ARENA_TUTORIAL_STEPS = TUTORIALS.find(g => g.id === 'arena').steps;

export const ARENA_TUTORIAL_SLIDES = [
  {
    kicker: 'ШАГ 1 ИЗ 5',
    title: 'Победи отряд соперника',
    text: 'В бою участвуют две команды по 4 карты. Каждая карта занимает свою линию. Побеждает отряд, у которого остались живые карты.',
    art: 'assets/arena/matchmaking.png',
    points: ['Следи за HP каждой карты', 'Победы повышают кубки и MMR'],
  },
  {
    kicker: 'ШАГ 2 ИЗ 5',
    title: 'Выбери карту и цель',
    text: 'Сначала нажми свою живую карту, затем любую живую карту противника. Линии не ограничивают выбор цели.',
    icon: '⚔',
    points: ['Одной живой картой можно атаковать повторно', 'Можно бить одну цель несколькими картами'],
  },
  {
    kicker: 'ШАГ 3 ИЗ 5',
    title: 'Читай силу карты',
    text: 'ATK показывает точный урон удара, HP — оставшееся здоровье. Выбирай цель по оставшемуся здоровью и атаке своей карты.',
    icon: '◇',
    points: ['Перед ударом проверь свою карту и цель', 'Уничтоженную карту выбрать нельзя'],
  },
  {
    kicker: 'ШАГ 4 ИЗ 5',
    title: 'Обменивайся ударами',
    text: 'После твоей атаки ИИ отвечает одним ударом, если бой ещё не завершён. Затем ты снова выбираешь атакующую карту и цель.',
    icon: '▱',
    points: ['Одна атака — один ответ ИИ', 'Живую карту можно выбрать снова'],
  },
  {
    kicker: 'ШАГ 5 ИЗ 5',
    title: 'Колоды и реплеи',
    text: 'Сохраняй три состава по четыре карты. После результата бой остаётся в истории и воспроизводится по событиям боя.',
    icon: '▶',
    points: ['После боя карты уходят на восстановление', 'Реплей не влияет на результат и рейтинг'],
  },
];

function withTimeout(register, timeoutMs = 450) {
  return new Promise(resolve => {
    let done = false;
    const finish = value => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    try { register(finish); } catch { finish(null); }
  });
}

export function createArenaTutorialSeenStore({ webApp, storage, key, userId = webApp?.initDataUnsafe?.user?.id, version = 4 } = {}) {
  // Explicit keys retain the legacy API; default keys isolate accounts and versions.
  key ??= `reverse_arena_tutorial_seen_v${encodeURIComponent(String(version))}:user:${encodeURIComponent(String(userId ?? 'anonymous'))}`;
  if (storage === undefined) {
    try { storage = globalThis.localStorage; } catch { storage = null; }
  }
  const deviceStorage = webApp?.DeviceStorage;
  const deviceAvailable = Boolean(
    deviceStorage
    && (typeof webApp?.isVersionAtLeast !== 'function' || webApp.isVersionAtLeast('9.0'))
  );

  async function hasSeen() {
    try {
      if (storage?.getItem(key) === '1') return true;
    } catch { }
    if (!deviceAvailable || typeof deviceStorage.getItem !== 'function') return false;
    const value = await withTimeout(done => {
      deviceStorage.getItem(key, (error, result) => done(error ? null : result));
    });
    if (value === '1') {
      try { storage?.setItem(key, '1'); } catch { }
      return true;
    }
    return false;
  }

  async function markSeen() {
    try { storage?.setItem(key, '1'); } catch { }
    if (!deviceAvailable || typeof deviceStorage.setItem !== 'function') return true;
    const result = await withTimeout(done => {
      deviceStorage.setItem(key, '1', (error, success) => done(error ? false : success !== false));
    });
    return result !== false;
  }

  return { hasSeen, markSeen };
}
